<div class="referral-container">
	<div class="cancel-btn" [mat-dialog-close]="true">
		<img src="../../../assets/Cancel (Gray-Black).svg" />
	</div>
	<div class="gift-icon">
		<img src="../../../assets/Gift.svg" />
	</div>
	<h1 class="referral-title">
		<span class="blue-text">Get $100</span>
		for <span class="underlined-text">each</span> friend you refer
	</h1>

	<mat-dialog-content>
		<p class="referral-description">
			You will earn a $100 Amazon Gift Card per referral for any school who signs up with your link,
			<b>with no upper limit!</b>
		</p>
		<h2 class="referral-steps">3 Steps to Start Earning</h2>
		<ul class="referral-items">
			<li>
				<img src="../../../assets/PaperAir.svg" class="icon" alt="" />
				<span>Apply to the Program</span>
			</li>
			<li>
				<img src="../../../assets/Link.svg" class="icon" alt="" />
				<span>If accepted, you will receive a unique referral link to share with your network!</span>
			</li>
			<li>
				<img src="../../../assets/Cash.svg" class="icon" alt="" />
				<span>When a referral (school) has a demo and purchases SmartPass, <b>you'll get a $100 Amazon Gift Card.</b></span>
			</li>
		</ul>
	</mat-dialog-content>
	<mat-dialog-actions class="full-width">
		<button mat-button class="learn-more-button" (click)="NavToReferralPage()">Learn More</button>
	</mat-dialog-actions>
</div>
